import { AlertCircle, ExternalLink } from 'lucide-react';
import { getAuth0ErrorInfo } from '../utils/auth0Errors';

interface AuthErrorDisplayProps {
  error: Error;
}

export const AuthErrorDisplay = ({ error }: AuthErrorDisplayProps) => {
  const errorInfo = getAuth0ErrorInfo(error);

  if (!errorInfo) return null;

  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-4">
      <div className="flex items-start gap-2">
        <AlertCircle className="w-5 h-5 text-red-500 mt-0.5 flex-shrink-0" />
        <div>
          <h3 className="font-semibold text-red-800 text-sm mb-1">
            {errorInfo.message}
          </h3>
          <p className="text-red-600 text-sm mb-2">
            {errorInfo.description}
          </p>
          <p className="text-red-700 text-sm font-medium">
            {errorInfo.action}
          </p>
          {errorInfo.docsUrl && (
            <a
              href={errorInfo.docsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-red-600 hover:text-red-800 text-sm mt-2"
            >
              <ExternalLink className="w-3 h-3" />
              View more information
            </a>
          )}
        </div>
      </div>
    </div>
  );
};
